import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";
import "../assets/styles/Main.scss";
import backgroundVideo from "../assets/videos/background_video_1_1080p.mp4";
import heroLoop from "../assets/media/hero_loop.mp4";
import heroPoster from "../assets/media/hero_loop.webp";
import StoreBadges from "./StoreBadges";
import PhoneVideo from "./PhoneVideo";

function Main() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      setIsMobile(/iPhone|iPad|iPod|Android/i.test(navigator.userAgent));
    };
    checkDevice();
  }, []);

  return (
    <div className="hero-container">
      <Helmet>
        <title>Goal Guru | Personalized Football Analytics Platform</title>
        <meta
          name="description"
          content="Track live football matches, filter the noise, and get personalized notifications built around the match dynamics and stats that matter to you."
        />
        <meta
          property="og:title"
          content="Goal Guru – Personalized Football Analytics Platform"
        />
        <meta
          property="og:description"
          content="Real-time football stats, match tracking, and a notification system that learns what you care about."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://goalguru.live" />
        <meta
          property="og:image"
          content="https://goalguru.live/og/home.png"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Goal Guru – Personalized Football Analytics Platform"
        />
        <meta
          name="twitter:description"
          content="Real-time football stats, match tracking, and a notification system that learns what you care about."
        />
        <meta
          name="twitter:image"
          content="https://goalguru.live/og/home.png"
        />
        <link rel="canonical" href="https://goalguru.live" />
      </Helmet>

      <div className="background-media">
        {!isMobile ? (
          <video className="background-video" autoPlay loop muted playsInline>
            <source src={backgroundVideo} type="video/mp4" />
          </video>
        ) : (
          <div className="background-fallback" />
        )}
        <div className="video-overlay" />
      </div>

      <div className="hero-layout">
        <div className="hero-content">
          <h1 className="hero-brand">
            <span className="hero-brand-icon" aria-hidden="true" />
            <span className="hero-title">Goal Guru</span>
          </h1>
          <p className="hero-tagline">Personalized Football Analytics Platform</p>

          <Link to="/smart-football-notifications/#playground" className="hero-cta">
            <Sparkles className="hero-cta-icon" />
            Try Smart Alerts
            <ArrowRight className="hero-cta-arrow" />
          </Link>

          <StoreBadges height={54} className="store-buttons" />
        </div>

        <div className="hero-media">
          <PhoneVideo
            autoplay
            size="small"
            src={heroLoop}
            poster={heroPoster}
            label="A Goal Guru smart alert fires during a live match; the user opens the match and the goal follows"
            className="hero-phone"
          />
        </div>
      </div>

      <div className="hero-scroll-hint">
        <span />
        <span />
        <span />
      </div>
    </div>
  );
}

export default Main;
